import type { QuestionProps } from '../eform.types'

export default function TextareaQuestion({  value, onChange, error }: QuestionProps) {
  const strValue = Array.isArray(value) ? value[0] ?? '' : value

  return (
    <div>
      <textarea
        value={strValue}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Your answer"
        rows={4}
        className={`w-full rounded-lg border px-4 py-3 text-sm resize-y transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary ${
          error ? 'border-red-300' : 'border-slate-200'
        }`}
      />
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  )
}
